<template>
  <container-app>
    <header-app
      :title="$t('promotion')"
      class="header-brand"
      to="menu"
    />
    <wrap>
      <div class="row">
        <div
          v-for="(promotion, index) in promotions "
          :key="index"
          class="col-sm-12 col-md-6 col-lg-4"
        >
          <div
            class="card"
            style="margin: 10px; border-radius: 20px;"
          >
            <div class="card-body">
              <div class="cc1">
                <h5 class="card-title">
                  {{ promotion.title }}
                </h5>
              </div>
              <div class="cc2">
                <button
                  class="btn d7 btn-primary"
                  @click="apply(promotion)"
                >
                  {{ $t('Apply') }}
                </button>
              </div>
            </div>
            <img
              class="card-img-top"
              :src="promotion.image_url"
              alt="Card image cap"
            >
          </div>
        </div>
      </div>
      <div
        v-if="promotions.length<1 "
        class="card text-center"
      >
        <img
          src="@/assets/nodata.svg"
          width="200"
          alt
          style="margin:auto"
        >
        <div class="card-body">
          <p>{{ $t('No_Promotions') }}</p>
        </div>
      </div>
    </wrap>
  </container-app>
</template>
<style lang="css">
.card-img-top {
  padding: 0;
  margin-bottom: -10px;
}
.cc1 {
  width: calc(100% - 87px);
  float: left;
}
.cc2 {
  float: left;
  text-align: right;
}
.d7 {
  color: #01336e;
  font-size: 16px;
  font-weight: 700;
  padding: 5px 16px;
  border: 1px solid #01336e;
  background: #fff;
  border-radius: 300px;
  position: relative;
  z-index: 3;
  -webkit-font-smoothing: antialiased;
}
</style>
<script>
  import store from "@/store";
  export default {
    name: "Promotions",
    middleware: "auth",
    computed: {
      promotions() {
        return store.getters["promotion/promotions"];
      },
      restaurant() {
        return store.getters["location_selected/placeSelected"] || {};
      },
    },
    mounted() {
      this.get_promotions();
    },
    methods: {
      apply(promotion) {
        this.$store.dispatch("order/applyPromotion", promotion);
        this.$router.push({ name: "basket" });
      },
      async get_promotions() {
        await store.dispatch("promotion/get_promotions", {
          restaurant_id: this.restaurant.id,
        });
      },
    },
  };
</script>